export interface IGraphLayoutDetails {
    cellSize: number;
    quadView: string;
    XN: number;
    XP: number;
    YN: number;
    YP: number;
    xInterval: number;
    yInterval: number;
}
export class Coordinates {
    canvasX: number;
    canvasY: number;
}
export class GraphPoints {
    coords: Coordinates[];
    graphPoints: Coordinates[];
    type: string;
    radiusOfCircle?: string;
}
export class GraphLayout {
    cellSize: string;
    quadView: string;
    XN: string;
    XP: string;
    YN: string;
    YP: string;
    xInterval: string;
    yInterval: string;
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/_models/Questions/GraphLayoutDetails/graphLayoutDetails.ts